export default __webpack_public_path__ + "static/media/UpperGI_set_up_Female_.661bc2d7.png";